import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import {
  useRetrieveCurrentPlanzone,
  useRetrieveZonesProjectsGantt,
  useSearch,
} from "@planzone/view-models";
import { SearchQuery, searchQuery } from "@planzone/dto";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { WorkspaceContext } from "@scenes/workspaceContext";
import { ProfileNavigation } from "@common/profileNavigation";
import { Props } from "./types";
import { Filters } from "./filters";
import { SearchResults } from "./searchResults";
import { Loader } from "./loader";
import styles from "./styles.scss";

function updateSearch(query: SearchQuery) {
  const url = new URL(window.location.href);

  url.searchParams.set("query", query.name);
  window.history.pushState(null, "", url.toString());
}

function useQuery() {
  return new URLSearchParams(
    window.location.search || window.location.hash.replace(/^#/, "?"),
  );
}

function SearchPage(_: Props) {
  const name = useQuery().get("query") || "";
  const { t } = useTranslation();
  const history = useNavigate();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestSuccess,
    isRequestPending,
    isRequestFailure,
    retrieveZonesProjectsGantt,
  } = useRetrieveZonesProjectsGantt();
  const [query, setQuery] = React.useState<SearchQuery>({
    ...searchQuery,
    types: ["project"],
    name,
    limit: 99999,
  });
  const {
    isRequestPending: isPending,
    searchResults,
    search,
  } = useSearch(query);

  React.useEffect(() => {
    !query.types &&
      !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveZonesProjectsGantt(planzone);
  }, [planzone.uuid, query.types]);

  React.useEffect(() => {
    isRequestSuccess && search(query);
  }, [isRequestSuccess]);

  // React.useEffect(() => {
  //   const syncState = () => {
  //     const newQuery =
  //       new URLSearchParams(window.location.search).get("query") || "";
  //
  //     if (!!newQuery) {
  //       search({ ...query, name: newQuery });
  //       setQuery({ ...query, name: newQuery });
  //     }
  //   };
  //
  //   const unRegister = history.listen(syncState);
  //
  //   return () => {
  //     unRegister();
  //   };
  // }, [search, query, setQuery]);

  return (
    <WorkspaceContext type="planzone">
      <div className={styles.searchPage}>
        <div className={styles.header}>
          <h1 className={styles.title}>{t("searchPage.title")}</h1>
          <div className={styles.profileNavigation}>
            <AssistantShortcut />
            <Notifications />
            <ProfileNavigation />
          </div>
        </div>
        <div className={styles.main}>
          <div className={styles.filters}>
            <Filters
              query={query}
              edit={setQuery}
              search={(query) => {
                if (!isPending) {
                  search(query);
                  updateSearch(query);
                }
              }}
            />
          </div>
          <div className={styles.searchResults}>
            {isPending || isRequestPending ? (
              <Loader />
            ) : (
              <SearchResults query={query} results={searchResults} />
            )}
          </div>
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { SearchPage };
